import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from './authContext';

const ProtectedRoute = ({ element: Component, role, ...rest }) => {
 const { user } = useContext(AuthContext);
 const userData = Array.isArray(user) ? user[0] : null;
 const params = new URLSearchParams(window.location.search);
 const paygroup_navigate = params.get("paygroup");
 const period_navigate = params.get("period");
  if (!userData) {
    // Only store redirectAfterLogin if paygroup and period are present and non-empty
    if (paygroup_navigate && paygroup_navigate !== '' && period_navigate && period_navigate !== '') {
      const redirectUrl = window.location.pathname + window.location.search;
      localStorage.setItem("redirectAfterLogin", redirectUrl);
    } else {
      // Clear any previous redirectAfterLogin for direct /login access
      localStorage.removeItem("redirectAfterLogin");
    }
    window.location.href = "/login";
  }

  if (role && user[0].Role !== role) {
    return <Navigate to="/404" replace />;
  }
  return Component;
};

export default ProtectedRoute;
